import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import WarningRoundedIcon from "components/atoms/_icons/WarningRoundedIcon"
import Dialog from "components/atoms/Dialog"

type LoginRequiredDialogProps = {
  open: boolean;
  message: string;
  onClose: () => void;
}

export default function LoginRequiredDialog(props: LoginRequiredDialogProps) {
  const { open, message, onClose } = props

  const { t } = useTranslation()
  const navigate = useNavigate()

  function handleLoginButtonClicked() {
    onClose()
    navigate(`/login?referer=${window.location.pathname}`)
  }

  return (
    <Dialog
      message={message}
      icon={<WarningRoundedIcon/>}
      buttons={[
        {
          label: t("auth.login"),
          mode: "primary",
          loading: false,
          disabled: false,
          onClick: handleLoginButtonClicked
        },
        {
          label: t("general.discard"),
          mode: "white",
          loading: false,
          disabled: false,
          onClick: onClose
        }
      ]}
      open={open}
      onClose={onClose}
    />
  )
}
